export default [
  {
    path: '/app/services',
    name: 'Services',
    component: () => import('@/views/Admin/Services/Index.vue'),
    meta: {
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_SERVICE_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/services/add',
    name: 'ServiceAdd',
    component: () => import('@/views/Admin/Services/Add.vue'),
    meta: {
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_SERVICE_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/services/edit/:id',
    name: 'ServiceEdit',
    component: () => import('@/views/Admin/Services/Edit.vue'),
    meta: {
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_SERVICE_EDIT',
      action: 'read',
    },
  },
]
